import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';

import GridCustomTile from './GridCustomTile';
import MobileGridView from './MobileGridView';

class GridView extends Component {
  static contextTypes = {
    currentUser: PropTypes.shape({}),
  };

  static propTypes = {
    children: PropTypes.node,
    threshold: PropTypes.string,
  };

  static defaultProps = {
    children: null,
    threshold: 'md',
    isOrderingGrid: false,
    isCardMobile: false,
  };

  render() {
    const { children, threshold, isOrderingGrid, isCardMobile } = this.props;
    const styles = {
      gridList: {
        display: 'flex',
        flexWrap: 'wrap',
        overflowY: 'auto',
        width: '100%',
      },
    };

    return (
      <div
        style={{ width: '100%', paddingLeft: isCardMobile ? "0px" : "10px", paddingRight: isCardMobile ? "0px" :"10px", marginTop: "30px"} }
      >
        <Grid container spacing={24} style={isOrderingGrid && !isCardMobile ? {maxWidth: '1200px', margin:'auto'}:{}}>
          {children}
        </Grid>
      </div>
    );
  }
}

GridView.GridCustomTile = GridCustomTile;
GridView.MobileGridView = MobileGridView;

export default GridView;
